/** @format */

import { cssVars } from '@atoms/GlobalStyles';
import { Theme } from '@emotion/react';

const base: Theme = {
  color: {
    background: {
      primary: '#F9FAFB',
      secondary: '#DDE4E9',
      error: cssVars.red,
      warning: cssVars.yellow,
      hover: '#347AB7',
    },
    border: {
      primary: cssVars.lightGrey,
      error: cssVars.red,
      warning: cssVars.yellow,
    },
    text: {
      link: '#347AB7',
      primary: '#000000',
      secondary: '#848484',
      error: cssVars.red,
      warning: cssVars.yellow,
      light: '#f9fab',
    },
    pseudo: {
      hover: '#347AB7',
      active: '',
    },
  },
};

export default base;
